import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { api } from "../api/api";

function TageslisteKarte({ label, datum, daten }) {
  const kistenLabel = label.replace(/^📋 /, "");
  return (
    <div>
      <h3 style={{ color: "#1565c0", marginBottom: "0.25rem" }}>
        {label} – {new Date(datum).toLocaleDateString("de-DE", { weekday: "long", day: "2-digit", month: "long" })}
      </h3>
      <p style={{ color: "#888", fontSize: "0.85rem", marginBottom: "0.75rem" }}>
        {daten.length} Bestellung{daten.length !== 1 ? "en" : ""}
      </p>
      {daten.length === 0
        ? <div className="card" style={{ textAlign: "center", color: "#aaa" }}>Keine Bestellungen.</div>
        : (
          <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
            {/* ── Zusammenfassung ── */}
            <div className="card" style={{ background: "#e3f2fd", border: "1.5px solid #90caf9" }}>
              <strong style={{ color: "#1565c0" }}>📊 Zusammenfassung</strong>
              <div style={{ marginTop: "0.5rem" }}>
                {Object.entries(
                  daten.reduce((acc, b) => {
                    const key = `${b.produktName} (${b.einheit})`;
                    acc[key] = (acc[key] || 0) + b.menge;
                    return acc;
                  }, {})
                ).map(([produkt, menge]) => (
                  <div key={produkt} style={{ fontSize: "0.95rem", color: "#1565c0" }}>
                    → <strong>{menge} ×</strong> {produkt}
                  </div>
                ))}
              </div>
            </div>

            <KistenRechner daten={daten} label={kistenLabel} />

            {daten.map(b => (
              <div key={b.bestellungId} className="card"
                style={{ padding: "0.75rem 1rem", border: "1.5px solid #bbdefb" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <strong>{b.vorname} {b.nachname}</strong>
                    <span style={{ color: "#888", fontSize: "0.85rem", marginLeft: "0.5rem" }}>{b.email}</span>
                  </div>
                  <span className="badge" style={{ background: "#e3f2fd", color: "#1565c0" }}>
                    {b.intervall ?? "Einzelbestellung"}
                  </span>
                </div>
                <div style={{ marginTop: "0.4rem", color: "#555", fontSize: "0.95rem" }}>
                  🥛 <strong>{b.menge} {b.einheit}</strong> {b.produktName}
                </div>
              </div>
            ))}
          </div>
        )
      }
    </div>
  );
}

export default function Molkerei() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [heute,  setHeute]  = useState([]);
  const [morgen, setMorgen] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || (user.rolle !== "Molkerei" && user.rolle !== "MolkereiAdmin" && user.rolle !== "Admin" && !user.isAdmin)) {
      navigate("/");
      return;
    }
    const heuteDatum  = new Date().toISOString().slice(0, 10);
    const morgenDatum = new Date(Date.now() + 86400000).toISOString().slice(0, 10);

    Promise.all([
      api.tagesbedarf.getByDatum(heuteDatum),
      api.tagesbedarf.getByDatum(morgenDatum),
    ]).then(([h, m]) => { setHeute(h); setMorgen(m); })
      .finally(() => setLoading(false));
  }, [user, navigate]);

  if (loading) return <div className="container" style={{ paddingTop: "3rem", textAlign: "center" }}>Lädt...</div>;

  return (
    <div className="container" style={{ maxWidth: 900 }}>
      <div style={{ display: "flex", alignItems: "center", gap: "1rem", margin: "1.5rem 0" }}>
        <div style={{
          width: 50, height: 50, borderRadius: "50%",
          background: "linear-gradient(135deg, #1565c0, #42a5f5)",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: "1.5rem", flexShrink: 0
        }}>🥛</div>
        <div>
          <h2 style={{ color: "#1565c0", margin: 0 }}>Molkerei – Tagesbedarf</h2>
          <p style={{ color: "#888", margin: 0, fontSize: "0.9rem" }}>
            Hallo {user?.vorname}! Hier siehst du was heute und morgen gebraucht wird.
          </p>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1.5rem" }}>
        <TageslisteKarte
          label="📋 Heute"
          datum={new Date()}
          daten={heute}
        />
        <TageslisteKarte
          label="📋 Morgen"
          datum={new Date(Date.now() + 86400000)}
          daten={morgen}
        />
      </div>

    </div>
  );
}

function kistenProFlasche(produktName) {
  const n = produktName.toLowerCase();
  const einweg = n.includes("einweg");
  if (n.includes("0,25") || n.includes("0.25"))  return 24;
  if (einweg)                                      return 12; // alle Einweg 1L
  if (n.includes("3 liter") || n.includes("3l"))  return 6;
  if (n.includes("2 liter") || n.includes("2l"))  return 9;
  if (n.includes("1 liter") || n.includes("1l"))  return 20;
  return null; // Eier, Sonstiges → einzeln
}

function KistenRechner({ daten, label }) {
  const alle = daten;
  if (alle.length === 0) return null;

  const summen = {};
  alle.forEach(b => {
    const key = `${b.produktName}||${b.einheit}`;
    summen[key] = (summen[key] || 0) + b.menge;
  });

  const einzel = [];   // Eier etc.
  const kisten = [];   // Flaschen

  Object.entries(summen).forEach(([key, gesamt]) => {
    const [produktName, einheit] = key.split("||");
    const pro = kistenProFlasche(produktName);
    if (pro === null) {
      einzel.push({ label: `${produktName} (${einheit})`, gesamt });
    } else {
      const volle    = Math.floor(gesamt / pro);
      const rest     = gesamt % pro;
      kisten.push({ label: `${produktName} (${einheit})`, gesamt, pro, volle, rest });
    }
  });

  kisten.sort((a, b) => a.label.localeCompare(b.label));
  einzel.sort((a, b) => a.label.localeCompare(b.label));

  return (
    <div className="card" style={{ background: "#f3e5f5", border: "1.5px solid #ce93d8", marginTop: "1.5rem" }}>
      <strong style={{ color: "#6a1b9a", fontSize: "1.05rem" }}>📦 Kisten – {label}</strong>
      <div style={{ marginTop: "0.75rem", display: "flex", flexDirection: "column", gap: "0.35rem" }}>
        {kisten.map(({ label, gesamt, pro, volle, rest }) => (
          <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline",
            fontSize: "0.95rem", color: "#4a148c", borderBottom: "1px solid #e1bee7", paddingBottom: "0.2rem" }}>
            <span>{label}</span>
            <span style={{ whiteSpace: "nowrap", marginLeft: "1rem" }}>
              <strong>{gesamt}</strong> Fl. → <strong>{volle} Kiste{volle !== 1 ? "n" : ""}</strong>
              {rest > 0 && <span style={{ color: "#9c27b0" }}> + {rest} lose</span>}
              <span style={{ color: "#aaa", fontSize: "0.78rem", marginLeft: "0.4rem" }}>({pro}/Kiste)</span>
            </span>
          </div>
        ))}
        {einzel.map(({ label, gesamt }) => (
          <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline",
            fontSize: "0.95rem", color: "#4a148c", borderBottom: "1px solid #e1bee7", paddingBottom: "0.2rem" }}>
            <span>{label}</span>
            <span style={{ whiteSpace: "nowrap", marginLeft: "1rem" }}>
              <strong>{gesamt}</strong> Stk. <span style={{ color: "#aaa", fontSize: "0.78rem" }}>(einzeln)</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
